import type { AllRouteEndpoints } from "../routeTypes";
export const sdkDebuggerRecordingIdStopCacheKeys: AllRouteEndpoints[] = ["/sdk/debugger/:app_group_id/all"];
